import React from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface Props {
    open: boolean;
    onClose: () => void;
    onSubmit: (note: string) => void;
    loading: boolean;
    licenseTitle: string;
    licenseKey: string;
}

const CollectRequestModal: React.FC<Props> = ({
                                                  open,
                                                  onClose,
                                                  onSubmit,
                                                  loading,
                                                  licenseTitle,
                                                  licenseKey,
                                              }) => {
    const [note, setNote] = React.useState("");

    const handleSubmit = () => {
        if (!note.trim()) {
            alert("وارد کردن علت الزامی است.");
            return;
        }

        // تایید نهایی
        const confirm = window.confirm("آیا از ثبت درخواست جمع‌آوری مطمئن هستید؟");
        if (!confirm) return;

        onSubmit(note.trim());
        setNote("");
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent dir="rtl" className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-emerald-700">
                        درخواست جمع‌آوری لایسنس
                    </DialogTitle>
                </DialogHeader>

                <div className="space-y-2 text-sm">
                    <p className="text-gray-700">
                        لطفاً علت درخواست خود را برای لایسنس زیر وارد کنید:
                    </p>

                    <div className="bg-emerald-50 border border-emerald-200 p-2 rounded text-xs">
                        محصول: <b>{licenseTitle}</b>
                        <br />
                        کلید لایسنس:{" "}
                        <span className="font-mono text-emerald-800" dir="ltr">
                            {licenseKey}
                        </span>
                    </div>

                    <Textarea
                        rows={4}
                        className="mt-2"
                        placeholder="علت درخواست را بنویسید..."
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                    />
                </div>

                <DialogFooter className="mt-4 space-x-3">
                    <Button
                        variant="outline"
                        onClick={onClose}
                        disabled={loading}
                        className="border-gray-300"
                    >
                        انصراف
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="bg-red-600 hover:bg-red-700 text-white"
                    >
                        {loading ? "در حال ثبت..." : "ثبت درخواست"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default CollectRequestModal;
